var quickLinkWrapper = $('.collection-header--quicklinks-wrapper')
if ($(quickLinkWrapper).hasClass('quick_links_same_width')) {
  const quicklinks_Arr = [];

  $(quickLinkWrapper).find("> a").map(function () {
    quicklinks_Arr.push($(this).width());
  }).get();

  const quicklinks_max_width = Math.max(...quicklinks_Arr);

  $(quickLinkWrapper).attr('data-max-width-element', quicklinks_max_width.toString());
  $(quickLinkWrapper).find("a > div").width(quicklinks_max_width);
  $(quickLinkWrapper).find("a > div").css('text-align', 'center');
}
else {
  if (!$(quickLinkWrapper).hasClass('quick_links_same_width')) {
    $(quickLinkWrapper).find('> a').width('initial');
  }
}